import type { SimulationConfig } from '../../config/schema';
import type { ControlSetupContext } from './helpers';

export function setupIntegrationControls(ctx: ControlSetupContext): void {
  const { config: c, controls: ui } = ctx;

  ui.bindControl('dt', (v) => {
    c.dt = parseFloat(v);
    ui.updateIntegrationInputs(c);
    ctx.markStale();
  }, 'change');

  ui.bindControl('iterations', (v) => {
    c.iterationsPerFrame = parseInt(v);
    ui.setText('iterValue', String(c.iterationsPerFrame));
  });

  ui.bindControl('maxIter', (v) => {
    c.maxIter = parseInt(v);
    ctx.markStale();
  }, 'change');

  ui.bindControl('perturb', (v) => {
    c.perturb = parseFloat(v);
    ui.setText('perturbValue', c.perturb.toFixed(6));
    ctx.markStale();
  });

  ui.bindControl('perturbDistribution', (v) => {
    c.perturbDistribution = v as SimulationConfig['perturbDistribution'];
    ctx.markStale();
  }, 'change');

  ui.bindControl('trials', (v) => {
    c.trials = Math.max(1, parseInt(v) || 1);
    ui.setText('trialsValue', String(c.trials));
    ctx.markStale();
  });

  ui.bindControl('neighborCount', (v) => {
    c.neighborCount = Math.max(1, Math.min(16, parseInt(v) || 1));
    ui.setText('neighborCountValue', String(c.neighborCount));
    ctx.markStale();
  });

  ui.bindControl('iterationsBeforeSnapshot', (v) => {
    c.iterationsBeforeSnapshot = Math.max(0, parseInt(v) || 0);
    ctx.markStale();
  }, 'change');

  ui.bindControl('iterationsAfterSnapshot', (v) => {
    c.iterationsAfterSnapshot = Math.max(0, parseInt(v) || 0);
    ctx.markStale();
  }, 'change');

  ui.bindControl('minimumImprovementToUpdate', (v) => {
    c.minimumImprovementToUpdate = Math.max(0, parseFloat(v));
    ctx.markStale();
  }, 'change');
}
